<template>
    <div>
        <h3>Enter Payment Method</h3>
        <p>
            <span class="title">{{errormessage}}</span>
        </p>
        <div class="stripe-card">
            <Card   :class='{ complete } '
                    ref="addcustomer"
                    v-if="stripepublickey"
                    :stripe='stripepublickey'
                    :options='stripeOptions'
                    @change='complete = $event.complete'
            ></Card>
        </div>
        <v-text-field
                class="mt-3 email"
                v-if="!this.cognito.user.attributes.email"
                outlined
                label="Email"
                v-model="email"
                :rules="[$store.state.rules.emailRules]"
        ></v-text-field>
        <BaseBtn v-if="$store.state.appdata"  dark
                 class='pay-with-stripe mt-2'
                 @click='createCustomer()'
                 :disabled='!complete'
                 :loading="loading">
            Next
            <v-icon class="ml-2">fas fa-arrow-circle-right</v-icon>
        </BaseBtn>
    </div>
</template>

<script>
  import {
    mapActions,
    mapState
  } from 'vuex'
  import {Card, createToken} from 'vue-stripe-elements-plus'
  import BaseBtn from "../BaseBtn";
  export default {
    components: {BaseBtn, Card},
    name: "CreateCustomer",
    data() {
      return {
        stripeOptions: {},
        complete: false,
        errormessage: '',
        loading:false,
        refreshing:false,
        email:''
      }
    },
    mounted() {

    },
    watch:{

    },
    computed:{
      ...mapState(['customer','cognito']),
      stripepublickey(){
        return this.$store.state.stripeClient
      }
    },
    methods: {
      ...mapActions(['post']),
      async createCustomer() {
        //todo - diff stripe live vs test tokens in appdata
        //will create customer if needed, then add a card.
        let em = this;
        em.loading = true;
        let token = await createToken().then(data => {
          if (data.error) {
            em.loading = false;
            em.errormessage = data.error.message;
            em.complete = false;
            return false;
          } else {
            em.complete = true;
            return data.token.id;
          }
        })
        if (!token) {
          em.loading = false;
          em.complete = false;
          return;
        }
        em.$refs.addcustomer.clear()
        let eml = (!this.cognito.user.attributes.email)?this.email:this.cognito.user.attributes.email
        if (!eml || eml.length<3) {
          em.loading = false;
          em.errormessage = 'Email Required';
          em.complete = false;
          return false;
        }
        let data = {
          stripeToken: token,
          email: eml,
          metadata: em.$store.state.cognito.user.attributes
        }
        let args = {
          url: this.$store.state.url + 'api/payments/stripegeneralusers/customer',
          method: 'POST',
          data: data
        }
        this.$store.dispatch('fetch', args)
            .then(function (response) { console.log(response)
              em.loading = false;
              let customer = response.customer;
              let appdata = response.appdata;
              if (customer && customer.type === 'StripeCardError') {
                em.failed(customer)
              } else {
                if (customer && customer.id) {
                  console.log(customer)
                  em.$store.commit('setCustomer', customer)
                  // wait for aws to set
                  // the stripe id into our appdata
                  if(appdata){
                    em.$store.commit('setAppdata',appdata)
                  }
                }
              }
            }).catch(function (e) {
          em.loading = false;
          console.log(e)
        })
      },
      failed(response) {
        let em = this;
        em.errormessage = '';
        em.errormessage = response.message;
        em.complete = false;
        em.loading = false;
        return false;
      }
    }
  }
</script>

<style scoped>
    .outline{
        border: solid thin lightgray;
        border-radius:5px;
    }
    .stripe-card {
        width: 320px;
        border: 1px solid grey;
        border-radius: 3px;
        padding:10px;
    }
    .stripe-card .complete {
        border-color: green;
    }
    .faded{
        background-color: rgba(50,50,50,.5);
    }
    a{
        text-decoration: none;
    }
    .email{
        width: 320px;
    }
</style>